import { Box, FormControl, FormErrorMessage, Text } from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';
import FormLabel from '~/components/FormLabel/FormLabel';
import { TagSelect } from '~/components/TagSelect';

import { MAX_CHARACTERS, TAG_PREFIX } from './Experience.constants';
import { ExperienceValues } from './Experience.types';

export const Experience = React.forwardRef<
  HTMLFormElement,
  FormikProps<ExperienceValues>
>(({ errors, handleSubmit, setValues, values }, ref) => {
  return (
    <>
      <Form onSubmit={handleSubmit} ref={ref}>
        <FormControl
          id="experienceTags"
          isInvalid={!!errors.experienceTags}
          marginBottom={6}
        >
          <Box marginBottom={3}>
            <FormLabel display="inline" fontWeight={400} fontSize="md">
              Highlight 2-4 brands you’ve worked with:
            </FormLabel>

            <Text display="inline" color="primary.300" fontSize="sm">
              (Max. 15 characters)
            </Text>
          </Box>

          <TagSelect
            maxCharacters={MAX_CHARACTERS}
            onChange={(tags) =>
              setValues(
                { experienceTags: tags },
                !!values.experienceTags.length,
              )
            }
            prefix={TAG_PREFIX}
            tagProps={{
              _active: { backgroundColor: 'secondary.700' },
              _hover: { backgroundColor: 'secondary.600' },
              colorScheme: 'secondary',
              variant: 'solid',
            }}
            tags={values.experienceTags ?? []}
            textInputPlaceholder="Brand name"
            textSubmitButton="Add Brand"
          >
            {({ renderUI }) => (
              <>
                <Box marginBottom={4}>
                  {renderUI()}

                  <FormErrorMessage data-testid="error-brands">
                    {errors.experienceTags}
                  </FormErrorMessage>
                </Box>
              </>
            )}
          </TagSelect>
        </FormControl>
      </Form>
    </>
  );
});
